

const LudzIcon = ({icon, size}) => {
    return(
        <i className={icon} style={{ fontSize: size || '1.5rem' }}  />
    )
}

export default LudzIcon;